"use strict";

const MobileDetect = require('mobile-detect');
const md = new MobileDetect(window.navigator.userAgent);

$(() => {

  const closeAll = () => {
    $("nav .nav-item.dropdown").find(".dropdown-menu, .dropdown-toggle").removeClass("show");
  }

  $("nav .nav-item.dropdown").on({
    mouseenter: (e) => {
      const dropdown = $(e.currentTarget);

      if (md.mobile()) {
        if (md.userAgent() !== "Safari") {
          dropdown.find("> a").addClass("touch-blocker");
        }
        dropdown.find("> a").addClass("show");
        dropdown.find(".dropdown-menu").addClass("show");

      } else if (dropdown.closest(".navbar-collapse").css("display") !== "flex") {
        dropdown.find("> a").addClass("touch-blocker");

      } else {
        closeAll();
        dropdown.find("> a").addClass("show");
        dropdown.find(".dropdown-menu").addClass("show");
      }
    },
    mouseleave: (e) => {
      const dropdown = $(e.currentTarget);
      if (dropdown.closest(".navbar-collapse").css("display") === "flex") {
        dropdown.find("> a").removeClass("show touch-blocker");
        dropdown.find(".dropdown-menu").removeClass("show");
      }
    }
  });

  $("nav .nav-item.dropdown > a").on({
    click: (e) => {
      const link = $(e.currentTarget);
      if (link.hasClass("touch-blocker")) {
        link.removeClass("touch-blocker");
        closeAll();
        link.addClass("show")
        link.closest(".dropdown").find(".dropdown-menu").addClass("show");
        e.preventDefault();
        e.stopPropagation();
      }
    }
  });
});
